import React from 'react';

function CardIcon7() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="25"
      fill="none"
      viewBox="0 0 38 25"
    >
      <g clipPath="url(#clip0_2_8264)">
        <path
          fill="#000"
          d="M35 .6H3c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3v-18c0-1.7-1.4-3-3-3z"
          opacity="0.07"
        ></path>
        <path
          fill="#D64D00"
          d="M35 1.6c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2v-18c0-1.1.9-2 2-2h32z"
        ></path>
        <path fill="#FF8A00" d="M15 19.6a7 7 0 100-14 7 7 0 000 14z"></path>
        <path fill="#9D3800" d="M23 19.6a7 7 0 100-14 7 7 0 000 14z"></path>
        <path
          fill="#6E0C0C"
          d="M22 12.6c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7 0 2.3 1.2 4.5 3 5.7 1.8-1.2 3-3.3 3-5.7z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2_8264">
          <path
            fill="#fff"
            d="M0 0H38V24H0z"
            transform="translate(0 .6)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CardIcon7;
